import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Sticky from 'react-stickynode'
import { Box, Container } from 'pcln-design-system'

const StickyNode = styled(Sticky)`
  > div {
    left: 0;
  }
`
const StickyEffectContainer = styled(Container)`
  padding: 16px 16px 0;
`

const StickyEffect = ({
  children,
  handleStickyEffectStateChange,
  enabled,
  isStickyInEffect,
  stickyHeight = 80
}) => {
  return (
    <StickyNode
      enabled={enabled}
      innerZ={1}
      onStateChange={handleStickyEffectStateChange}
      enableTransforms={false}
    >
      {isStickyInEffect ? (
        <Box width='100vw' pb={1} color='text.base'>
          <StickyEffectContainer maxWidth={1280} stickyHeight={stickyHeight}>
            {children}
          </StickyEffectContainer>
        </Box>
      ) : children}
    </StickyNode>
  )
}

StickyEffect.displayName = 'StickyEffect'
StickyEffect.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  handleStickyEffectStateChange: PropTypes.func,
  enabled: PropTypes.bool.isRequired,
  isStickyInEffect: PropTypes.bool.isRequired,
  stickyHeight: PropTypes.number
}

export default StickyEffect

/*
 * Referece: https://github.com/yahoo/react-stickynode/blob/master/src/Sticky.jsx#L16
 * // constants
 * const STATUS_ORIGINAL = 0; // The default status, locating at the original position.
 * const STATUS_RELEASED = 1; // The released status, locating at somewhere on document but not default one.
 * const STATUS_FIXED = 2; // The sticky status, locating fixed to the top or the bottom of screen.
*/
export const StickyEffectData = {
  STATUS_ORIGINAL: Sticky.STATUS_ORIGINAL,
  STATUS_RELEASED: Sticky.STATUS_RELEASED,
  STATUS_FIXED: Sticky.STATUS_FIXED
}
